import { metrics, ResponsivePictureLayout } from '@news-mono/component-library'
import { TogglesReduxState } from '@news-mono/web-common'
import { layout } from '../../App.routing'

const breakingNews = layout.component({
    type: 'breaking-news',
    props: {
        dataDefinitionArgs: {
            type: 'curation',
            name: 'breaking-news',
            offset: 0,
            pageSize: 1,
        },
    },
})

const westLiveBillboard = layout.component({
    type: 'the-west-live-billboard',
    feature: 'the-west-live',
    props: {
        showSponsorLogo: true,
        verticalSpacing: ['unset', 'md'],
        twlLogoAdUnit: {
            hiddenUntilLoaded: false,
            noticePosition: 'none',
            padding: [metrics.thewest.margins.md, 0, 0, 0],
            slot: {
                id: 'twl-banner',
                size: 'theWestLiveLogo',
            },
        },
    },
})

function homepageHeroSegment() {
    return layout.component({
        type: 'sierra',
        props: {
            verticalSpacing: 'gridGap',
            fixedRatios: ['16:9'],
            heroImageLayout: ResponsivePictureLayout.ObjectFitContain,
            cardOrientation: {
                type: 'Landscape-Portrait',
                maxBreakpoint: 'md',
            },
            cardLayout: ['the-west-hero', 'hero-support'],
            restrictedVideoPlaybackMode: 'entitled',
            dataDefinitionArgs: {
                type: 'curation',
                name: 'home',
                offset: 0,
                pageSize: 3,
            },
        },
    })
}

const mobileParalaxAdUnit = [
    layout.component({
        type: 'ad-unit',
        feature: ['running-parallax', true],
        props: {
            noticePosition: 'below-center',
            hiddenUntilLoaded: true,
            breakout: {
                kind: 'percentage',
                value: 5,
                breakpoint: metrics.thewest.siteMetrics.mainContentWidth,
            },
            padding: [0, 0, metrics.thewest.margins.md, 0],
            slot: {
                id: 'mobile-parallax',
                size: 'mobileParallax',
            },
        },
    }),
    layout.component({
        type: 'ad-unit',
        feature: ['running-parallax', false],
        props: {
            noticePosition: 'below-center',
            padding: [metrics.thewest.margins.md, 0],
            slot: {
                id: 'mrec-parallax',
                size: 'mobileMrec',
            },
        },
    }),
]

const homepageSubheroSegment = layout.component({
    type: 'uniform',
    props: {
        section: 'default',
        verticalSpacing: 'xl',
        cardOrientation: { type: 'Landscape-Portrait' },
        cardLayout: [
            { type: 'november', listLength: 5 },
            ['large-card'],
            ['large-card-mdNoImage', 'large-card-mdNoImage'],
            ['large-card-mdNoImage', 'large-card-mdNoImage'],
        ],
        dataDefinitionArgs: {
            type: 'aggregated',
            sources: [
                {
                    type: 'curation',
                    name: 'top-stories',
                    offset: 0,
                    pageSize: 5,
                },
                {
                    type: 'curation',
                    name: 'home',
                    offset: 2,
                    pageSize: 6,
                    injectMetadataStory: {
                        kind: 'marketing-redirect-tile',
                        metadataKey: 'promotional-card',
                        position: 1,
                    },
                },
            ],
        },
    },
})

const paralaxAdUnit = [
    layout.component({
        type: 'ad-unit',
        feature: ['running-parallax', true],
        props: {
            noticePosition: 'below-center',
            hiddenUntilLoaded: true,
            breakout: {
                kind: 'percentage',
                value: 5,
                breakpoint: metrics.thewest.siteMetrics.mainContentWidth,
            },
            padding: [0, 0, metrics.thewest.margins.lg, 0],
            slot: {
                id: 'parallax',
                size: 'desktopParallax',
            },
        },
    }),
    layout.component({
        type: 'ad-unit',
        feature: ['running-parallax', false],
        props: {
            noticePosition: 'below-center',
            padding: [metrics.thewest.margins.lg, 0],
            slot: {
                id: 'leaderboard-billboard-parallax',
                size: 'desktopLeaderboardBillboard',
            },
        },
    }),
]

export function homeSegment(toggleValues: TogglesReduxState) {
    return layout.nestedComposition({
        type: 'thor',
        props: {
            hasBackgroundFill: false,
            containerWidth: '100%',
            verticalGutters: false,
            horizontalGutters: true,
        },
        contentAreas: {
            main: [
                breakingNews,
                westLiveBillboard,
                homepageHeroSegment(),

                ...mobileParalaxAdUnit,
                homepageSubheroSegment,
                ...paralaxAdUnit,
            ],
        },
    })
}
